import React, { useContext, useEffect, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import AwardBatchAccordion from "../Contents/Award/AwardBatchAccordion";
import { Button, IconButton, TextField } from "@mui/material";
import PopupDialog from "../../PopupDialog/PopupDialog";
import { Getrequest } from "../../../context/AxiosRequest";
import { ContextData } from "../../../context/Context";
import InnerLoarder from "../../../routes/InnerLoarder";

function Award() {



  const [searchText, setSearchText] = useState("");
  const [Display,setDisplay] = useState("undergraduate");
  const [ApplicantData,setApplicantData] = useState(null)
  const [loadStatus,setloadStatus] = useState(false)
  const {accesstoken} = useContext(ContextData)

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const HandleDisplay = (type) =>{

           setloadStatus(true)
      if(type === "undergraduate"){
          setDisplay("postgraduate")
      }
 

      if(type === "postgraduate"){
        setDisplay("undergraduate")
    }


  }



   useEffect(()=>{

    setloadStatus(true)
      
          async function FetchData() {

                          const response = await Getrequest(`auth/get_list_for_award/${Display}`,accesstoken)
                               setApplicantData(response)
                                setloadStatus(false)
                           }
           
                           FetchData()


   },[Display])

 


  return (
    <div className="h-[92vh] p-6">
      <h1 className="font-bold text-2xl">Award</h1>

      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <div className=" award-flex-con d-flex">
        <div
          style={{ height: "37.5rem" }}
          className="award w-2/4 bg-slate-100  overflow-auto"
        >
          <div className="buttons d-flex justify-between items-center p-3">
            {/*  */}
            <PopupDialog type="export-excel" />
            <div>
              <Button onClick={()=>HandleDisplay("postgraduate")} disabled={Display === "undergraduate"} sx={{background:"purple"}} variant="contained">undergraduate List</Button>
              <Button onClick={()=>HandleDisplay("undergraduate")} disabled={Display === "postgraduate"} sx={{marginLeft:"5px",background:"green"}} variant="contained">Postgraduate List</Button>
            </div>
            <PopupDialog type="award" />
            {/* <Button variant="contained">Award All</Button> */}
          </div>
          <div> 
             <h3 className="text-center capitalize font-extrabold">{Display} List</h3>
          </div>
          <ul className="ver-aside-ul p-3">
            { loadStatus  &&  
                <div className="w-full h-full flex justify-center items-center">
                   <div className="w-96">
                   <InnerLoarder />
                   <p className='text-center font-extrabold text-xs'>Powered By MastermindTech</p>
                   </div> </div>}
            {ApplicantData && ApplicantData.map((name, index) => (
              <li key={index} className="d-flex justify-between items-center border-t-2 border-blue-950 border-solid">
                <span>
                  <AccountCircleIcon /> {name.fname} {name.lname}
                </span>{" "}
               {/*  <Button variant="outlined">Award</Button> */}
              </li>
            ))}
          </ul>
        </div>
        <div style={{ height: "36rem" }} className="batch w-2/4 overflow-auto">
          {/* <div className="search p-3">
            <TextField
              label="Search by batch"
              variant="outlined"
              value={searchText}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              margin="normal"
            />
          </div> */}
          <div>
            <AwardBatchAccordion batch="Batch 1" />
            <AwardBatchAccordion batch="Batch 2" />
            <AwardBatchAccordion batch="Batch 3" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Award;
